import Vue from 'vue';
import {$http} from '@/utils/https';
import moment from 'moment';
import store from '@/store'
import _ from 'lodash'
import {
    ADD_ITEM_TO_BASKET,
    REMOVE_ITEM_FROM_BASKET,
    RESET_BASKET,
    CHECK_PROMO_CODE_LOADING,
    SET_EDIT_BASKET_ITEM,
    SHOW_POPUP_EDIT_TO_BASKET,
    DECREMENT_BASKET_EDIT_COUNT,
    INCREMENT_BASKET_EDIT_COUNT,
    SET_BASKET_EDIT_COUNT,
    REPLACE_ITEM_IS_BASKET,
    BUY_REQUISITES_LOADING,
    SET_PROMO_CODE_IN_BASKET,
    SET_DISCOUNT,
    RESET_DISCOUNT,
    SHOW_POPUP_THANKS,
    SET_DATA_REMOVE_FROM_BASKET,
    SHOW_POPUP_REMOVE_FROM_BASKET,
    INCREMENT_BASKET_LIST_COUNT,
    DECREMENT_BASKET_LIST_COUNT,
    SET_BASKET_LIST_COUNT,
    FRESH_BASKET_ITEMS
} from '../mutation-types';
import {
    CHECK_PROMO_CODE,
    RESERVED_REQUISITES
} from '../action-types';

function save() {
    const parsed = JSON.stringify(state.basket);
    localStorage.setItem('products', parsed);
}

function calculateItemTotalPrice(obj) {
    const start = moment(obj.from, "YYYY-MM-DD");
    const end = moment(obj.to, "YYYY-MM-DD");

     //Difference in number of days
     const different = moment.duration(start.diff(end)).asDays();

     obj.days = parseInt(Math.abs(different)) + 1;
     obj.img = obj.img ? obj.img : require('@/assets/img/default-img.jpg');
     obj.warrantyAmount = Math.round((obj.selectCount * obj.warranty_price) * 100) / 100;
     if(store.state.profile.user){
         if(store.state.profile.user.inner){
             let price = 0;
             const remainder = obj.days % 60;
             const iterationValue = (obj.days - remainder) / 60;
             const amountWithIterations = (iterationValue * (obj.price / 2)) * obj.selectCount;
             price = price + amountWithIterations;
             const amountRemainder = remainder * obj.price_rent;
             if(amountRemainder >= (obj.price / 2) ){
                 price = price + ((obj.price / 2) * obj.selectCount);
             }else{
                 price = price + (amountRemainder * obj.selectCount);
             }
             obj.totalPrice = price;
         }else{
             obj.totalPrice = Math.round((obj.days * obj.price_rent * obj.selectCount) * 100) / 100;
         }
     }else{
         obj.totalPrice = Math.round((obj.days * obj.price_rent * obj.selectCount) * 100) / 100;
     }
 }


const state = {
    showPopupRemoveItem: false,
    removeDataItem: null,
    countBasketItems: 0,
    buyLoading: false,
    showThanks: false,
    promoCode: '',
    discount: null,
    editCount: 0,
    showPopupEdit: false,
    loadingPromoCode: false,
    editedItem: null,
    basket: localStorage.getItem('products') ? JSON.parse(localStorage.getItem('products')) : [],
};

const getters = {
    showPopupRemoveItem: state => state.showPopupRemoveItem,
    removeDataItem: state => state.removeDataItem,

    promoCode: state => state.promoCode,
    countBasketItems: state => () => {
        let count = 0;
        state.basket.forEach(e => {
            count = count + e.selectCount;
        });
        return count;
    },
    showThanks: state => state.showThanks,
    discount: state => state.discount,
    editCount: state => state.editCount,
    buyLoading: state => state.buyLoading,
    showPopupEdit: state => state.showPopupEdit,
    editedItem: state => state.editedItem,
    loadingPromoCode: state => state.loadingPromoCode,
    basket: state => state.basket || [],
};

const actions = {
    [CHECK_PROMO_CODE]: async ({commit}, payload) => {
        commit(CHECK_PROMO_CODE_LOADING, true);
        commit(RESET_DISCOUNT);
        try {
            // eslint-disable-next-line
            const response = await $http.get(`v1/check_promo?promoCode=${payload}`);

            commit(RESET_DISCOUNT);
            commit(SET_DISCOUNT, response.data);
            return response.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHECK_PROMO_CODE_LOADING, false);
        }
    },
    [RESERVED_REQUISITES]: async ({commit}, payload) => {
        commit(BUY_REQUISITES_LOADING, true);
        try {
            // eslint-disable-next-line
            const response = await $http.post('v1/cart/checkout', payload);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(BUY_REQUISITES_LOADING, false);
        }
    },
};

const mutations = {
    [ADD_ITEM_TO_BASKET](state, obj) {

        state.basket.map((e, i) => {
            if(e.id === obj.id){
                if(e.to === obj.to && e.from === obj.from){
                    obj.selectCount = obj.selectCount + e.selectCount;
                    Vue.delete(state.basket, i);
                }
            }
        });

        calculateItemTotalPrice(obj);
        state.basket.push(obj);
        save();
    },
    [REMOVE_ITEM_FROM_BASKET](state, obj) {
        state.basket.splice(obj.index, 1);
        save();
    },
    [SET_EDIT_BASKET_ITEM](state, obj) {
        state.editedItem = obj;
    },
    [FRESH_BASKET_ITEMS](state) {
        state.basket.map(e => {
            return calculateItemTotalPrice(e);
        });
        save();
    },
    [REPLACE_ITEM_IS_BASKET](state, obj) {

        let isDublicated = false;
        let dublicatedIndex = null;

        state.basket.map((e, index) => {
            if(e.id === obj.id && obj.index !== index){
                if(e.to === obj.to && e.from === obj.from){
                    isDublicated = true;
                    dublicatedIndex = index;
                }
            }
        });
        if(isDublicated){
            state.basket[dublicatedIndex].selectCount = state.basket[dublicatedIndex].selectCount + obj.selectCount;
            state.basket.splice(obj.index, 1);

            state.basket.map(e => {
                return calculateItemTotalPrice(e);
            });
            save();
        }else{
            calculateItemTotalPrice(obj);

            Vue.set(state.basket, obj.index, obj);
            save();
        }

    },
    [SHOW_POPUP_EDIT_TO_BASKET](state, status) {
        state.showPopupEdit = status;
    },
    [RESET_BASKET](state) {
        localStorage.removeItem('products');
        state.basket = [];
    },
    [CHECK_PROMO_CODE_LOADING](state, status) {
        state.loadingPromoCode = status;
    },
    [DECREMENT_BASKET_EDIT_COUNT](state) {
        if (state.editCount > 1) {
            state.editCount--;
        }
    },
    [INCREMENT_BASKET_EDIT_COUNT](state) {
        state.editCount++;
    },
    [INCREMENT_BASKET_LIST_COUNT](state, obj) {
        obj.selectCount = obj.selectCount + 1;
        calculateItemTotalPrice(obj);

        Vue.set(state.basket, obj.index, obj);
        save();
    },
    [SET_BASKET_LIST_COUNT](state, obj) {
        calculateItemTotalPrice(obj);

        Vue.set(state.basket, obj.index, obj);
        save();
    },
    [DECREMENT_BASKET_LIST_COUNT](state, obj) {
        obj.selectCount = obj.selectCount - 1;
        calculateItemTotalPrice(obj);

        Vue.set(state.basket, obj.index, obj);
        save();
    },
    [SET_BASKET_EDIT_COUNT](state, val) {
        state.editCount = val;
    },
    [BUY_REQUISITES_LOADING](state, status) {
        state.buyLoading = status;
    },
    [SET_PROMO_CODE_IN_BASKET](state, code) {
        state.promoCode = code;
    },
    [SET_DISCOUNT](state, data) {
        state.discount = data.discount;
    },
    [RESET_DISCOUNT](state) {
        state.discount = null;
    },
    [SHOW_POPUP_THANKS](state, status) {
        state.showThanks = status;
    },
    [SHOW_POPUP_REMOVE_FROM_BASKET](state, status) {
        state.showPopupRemoveItem = status;
    },
    [SET_DATA_REMOVE_FROM_BASKET](state, data) {
        state.removeDataItem = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
